import { createSlice } from '@reduxjs/toolkit'


/**
 * Ce slice gère les messages flash dans l'application.
 * Il permet d'ajouter et de supprimer des messages flash, qui peuvent être utilisés pour afficher
 * des notifications de succès, d'erreur ou d'autres types de notifications à l'utilisateur.
 * Format : { text: "Texte du message de la notification"
 *            type: "info", "success", "error", "warning"
 *            persisted: true || false pour indiquer si le message s'effacera automatiquement au bout de 5 secondes (cf flashMessages.jsx)
 *          }
 */
const flashMessagesSlice = createSlice({
  name: 'flashMessages',
  initialState: [],
  reducers: {
    addFlashMessage: (state, action) => {
      state.push(action.payload)
    },
    removeFlashMessage: (state, action) => {
      return state.filter((_, index) => index !== action.payload)
    },
  },
})

export const { addFlashMessage, removeFlashMessage } = flashMessagesSlice.actions
export default flashMessagesSlice.reducer